import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { enableMapSet } from 'immer';
import { initLocale } from './locale/localeUtils';
import bugsnagReporting from './utils/bugsnag';

import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

initLocale();
enableMapSet();

const root = ReactDOM.createRoot(document.getElementById('root'));

const router = (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

root.render(
  <React.StrictMode>
    { bugsnagReporting(router) }
  </React.StrictMode>
);

// for testing non-strict mode:
// root.render(
//   bugsnagReporting(router)
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
